import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Route, Redirect, Switch } from 'react-router-dom';
import { Segment, Container, Menu } from 'semantic-ui-react';

import { es404 } from '../../Errors';
import {
  AlertBox,
  ConfirmBox,
  // setAlertMsg,
  // askConfirmation,
} from '../../../components/Modals';
import { MenuLinkItem, ThemeSelector } from '../../../components/Menu';
import { base } from '../../../config/constants';
import Send from '../_common/Send';
import History from '../_common/History';
import EditTheme from '../_common/EditTheme';
import AddTheme from '../_common/AddTheme';
import ListRecipients from '../_common/ListRecipients';

export default class Citizenly extends Component {
  static propTypes = {
    habilitations: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedThemeId: null,
      selectedThemeName: '',
      manageableThemesLoading: false,
      manageableThemes: [],
    };
  }

  componentDidMount() {
    this.bindOrRebindManageableThemes();
  }

  bindOrRebindManageableThemes = (force = false) => {
    if (!this.state.manageableThemesLoading) {
      this.setState({ manageableThemesLoading: true });
    }
    if (this.listBinding !== null) {
      base.removeBinding(this.listBinding);
    }
    this.listBinding = base.listenTo('citizenly', {
      context: this,
      state: 'manageableThemes',
      asArray: true,
      queries: {
        orderByKey: true,
      },
      then: (themes) => {
        // console.log(themes);
        const filteredThemes = this.props.habilitations.superuser
          ? themes : _.filter(themes, theme => this.props.habilitations.citizenly[theme.key]);
        // console.log(this.state.selectedThemeId || filteredThemes[0].key || null);
        // console.log(themes, filteredThemes)
        this.setState({
          manageableThemesLoading: false,
          manageableThemes: filteredThemes,
          selectedThemeId:
          (this.state.selectedThemeId && !force ? this.state.selectedThemeId : false)
          || (!filteredThemes[0] || filteredThemes[0].key)
          || null,
          selectedThemeName:
          (this.state.selectedThemeName && !force ? this.state.selectedThemeName : false)
          || (!filteredThemes[0] || filteredThemes[0].nom)
          || '',
        });
      },
    });
  }

  bringStateUp = (spreadMe = {}) => {
    this.setState({
      ...this.state,
      ...spreadMe,
    });
  }

  listBinding = null;

  render() {
    return (
      <Container>
        <Segment>
          <Menu secondary pointing stackable>
            <MenuLinkItem
              to="/citizenly/send"
              activeOnlyWhenExact={false}
              label="Envoyer une notification"
            />
            <MenuLinkItem to="/citizenly/history" label="Historique des notifications" />
            <MenuLinkItem
              to="/citizenly/recipients"
              label="Destinataires"
            />
            <MenuLinkItem
              to="/citizenly/manage"
              label="Configuration"
            />
            <MenuLinkItem
              to="/citizenly/create"
              label="Nouvelle commune"
              otherCondition={this.props.habilitations && this.props.habilitations.superuser === true}
            />
            <Switch>
              <Route path="/citizenly/create" component={() => null} />
              <Route path="/citizenly/send" component={() => null} />
              <Route
                path="/citizenly"
                component={() => (
                  <Menu.Item
                    position="right"
                    style={this.state.manageableThemes.length > 1 ? { padding: 0, marginTop: -10 } : {}}
                  >
                    <ThemeSelector
                      defaultValue={this.state.selectedThemeId !== null ? this.state.selectedThemeId : ''}
                      list={this.state.manageableThemes}
                      onSelect={
                        v => this.setState({
                          selectedThemeId: v,
                          selectedThemeName: _.filter(this.state.manageableThemes, i => i.key === v)[0].nom,
                        })}
                      label="Commune"
                    />
                  </Menu.Item>
                )}
              />
            </Switch>
          </Menu>
          <Container>
            <Switch>
              <Route
                path="/citizenly/send"
                component={props => (<Send
                  habilitations={this.props.habilitations}
                  availableThemes={this.state.manageableThemes}
                  themeType="citizenly"
                  {...props}
                />)}
              />
              <Route
                path="/citizenly/history"
                component={props => (<History
                  habilitations={this.props.habilitations}
                  themeId={this.state.selectedThemeId}
                  themeType="citizenly"
                  {...props}
                />)}
              />
              <Route
                path="/citizenly/recipients"
                component={props => (<ListRecipients
                  habilitations={this.props.habilitations}
                  themeId={this.state.selectedThemeId}
                  themeName={this.state.selectedThemeName}
                  themeType="citizenly"
                  {...props}
                />)}
              />
              <Route
                path="/citizenly/manage"
                component={props => (<EditTheme
                  habilitations={this.props.habilitations}
                  themeId={this.state.selectedThemeId}
                  bringStateUp={this.bringStateUp}
                  deletedThemeId={() => this.bindOrRebindManageableThemes(true)}
                  themeType="citizenly"
                  {...props}
                />)}
              />
              <Route
                path="/citizenly/create"
                component={props => (<AddTheme
                  habilitations={this.props.habilitations}
                  themeId={this.state.selectedThemeId}
                  manageableThemes={this.state.manageableThemes}
                  bringStateUp={this.bringStateUp}
                  themeType="citizenly"
                  // deletedThemeId={() => this.bindOrRebindManageableThemes(true)}
                  {...props}
                />)}
              />
              <Redirect exact from="/citizenly" to="/citizenly/send" />
              <Route component={es404} />
            </Switch>
          </Container>
          <AlertBox
            propagateClosure={() => this.setState({ alert: { open: false } })}
            {...this.state.alert}
          />
          <ConfirmBox
            propagateClosure={() => this.setState({ confirm: { open: false } })}
            {...this.state.confirm}
          />
        </Segment>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/Citizenly/index.js